import { Controller } from "@hotwired/stimulus"

// Manages primary + secondary color selection with presets, custom picker, and live preview.
export default class extends Controller {
  static targets = [
    "primaryValue", "primaryPreset", "primaryCustom", "primaryHex",
    "secondaryValue", "secondaryPreset", "secondaryCustom", "secondaryHex",
    "previewPrimary", "previewSecondary", "previewLabel"
  ]

  selectPrimaryPreset(e) {
    const hex = e.currentTarget.dataset.hex
    this.primaryValueTarget.value = hex
    this.primaryCustomTarget.value = hex
    this.primaryHexTarget.value = hex
    this.updatePrimaryPresetHighlight(hex)
    this.updatePreview()
  }

  selectPrimaryCustom(e) {
    const hex = e.target.value
    this.primaryValueTarget.value = hex
    this.primaryHexTarget.value = hex
    this.updatePrimaryPresetHighlight(null)
    this.updatePreview()
  }

  syncPrimaryHex(e) {
    let val = e.target.value.trim()
    if (!val.startsWith("#")) val = "#" + val
    if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
      this.primaryValueTarget.value = val
      this.primaryCustomTarget.value = val
      this.updatePrimaryPresetHighlight(null)
      this.updatePreview()
    }
  }

  selectSecondaryPreset(e) {
    const hex = e.currentTarget.dataset.hex || ""
    this.secondaryValueTarget.value = hex
    if (this.hasSecondaryCustomTarget) this.secondaryCustomTarget.value = hex || "#ffffff"
    if (this.hasSecondaryHexTarget) this.secondaryHexTarget.value = hex
    this.updateSecondaryPresetHighlight(hex)
    this.updatePreview()
  }

  selectSecondaryCustom(e) {
    const hex = e.target.value
    this.secondaryValueTarget.value = hex
    if (this.hasSecondaryHexTarget) this.secondaryHexTarget.value = hex
    this.updateSecondaryPresetHighlight(null)
    this.updatePreview()
  }

  syncSecondaryHex(e) {
    let val = e.target.value.trim()
    if (!val.startsWith("#")) val = "#" + val
    if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
      this.secondaryValueTarget.value = val
      if (this.hasSecondaryCustomTarget) this.secondaryCustomTarget.value = val
      this.updateSecondaryPresetHighlight(null)
      this.updatePreview()
    }
  }

  updatePreview() {
    const primary = this.primaryValueTarget?.value || "#f8f8f8"
    const secondary = this.secondaryValueTarget?.value || ""

    if (this.hasPreviewPrimaryTarget) {
      this.previewPrimaryTarget.style.backgroundColor = primary
    }
    if (this.hasPreviewSecondaryTarget) {
      this.previewSecondaryTarget.style.backgroundColor = secondary || "#ffffff"
      this.previewSecondaryTarget.style.display = secondary ? "block" : "none"
    }
    if (this.hasPreviewLabelTarget) {
      this.previewLabelTarget.textContent = secondary ? "Dual-color" : "Single-color"
    }
  }

  updatePrimaryPresetHighlight(hex) {
    if (!this.hasPrimaryPresetTarget) return
    this.primaryPresetTargets.forEach((btn) => {
      const isSelected = hex && btn.dataset.hex === hex
      btn.classList.toggle("border-primary-500", isSelected)
      btn.classList.toggle("bg-primary-50", isSelected)
      btn.classList.toggle("dark:bg-primary-900/20", isSelected)
      btn.classList.toggle("border-gray-200", !isSelected)
      btn.classList.toggle("dark:border-gray-600", !isSelected)
    })
  }

  updateSecondaryPresetHighlight(hex) {
    if (!this.hasSecondaryPresetTarget) return
    this.secondaryPresetTargets.forEach((btn) => {
      const btnHex = btn.dataset.hex || ""
      const isSelected = (hex === "" && btnHex === "") || (hex && btnHex === hex)
      btn.classList.toggle("border-primary-500", isSelected)
      btn.classList.toggle("bg-primary-50", isSelected)
      btn.classList.toggle("dark:bg-primary-900/20", isSelected)
      btn.classList.toggle("border-gray-200", !isSelected)
      btn.classList.toggle("dark:border-gray-600", !isSelected)
    })
  }
}
